import type { Catalog } from '../types';

/**
 * As mensagens que o app escreve quando algo falha.
 *
 * **Não cobrem as mensagens do servidor.** O backend responde em inglês e o `errorMessage` repassa
 * o texto dele quando é uma mensagem de domínio — então um usuário em português ainda vê "Invalid
 * credentials" vindo da API. É dívida conhecida e registrada; fechá-la exige `Accept-Language` no
 * backend. O que está aqui é o que o **cliente** decide dizer.
 */
export const errors = {
  'errors.network': { pt: 'Sem conexão. Verifique sua internet.', en: 'No connection. Check your internet.' },
  'errors.unreachable': {
    pt: 'Não foi possível falar com o servidor',
    en: 'Could not reach the server',
  },
  'errors.rateLimited': {
    pt: 'Muitas requisições. Tente de novo em {seconds}s.',
    en: 'Too many requests. Try again in {seconds}s.',
  },
  'errors.rateLimitedSoon': {
    pt: 'Muitas requisições. Aguarde um instante e tente de novo.',
    en: 'Too many requests. Wait a moment and try again.',
  },
  'errors.server': {
    pt: 'O servidor não respondeu. Tente de novo em instantes.',
    en: 'The server did not respond. Try again in a moment.',
  },
  'errors.generic': { pt: 'Algo deu errado. Tente de novo.', en: 'Something went wrong. Try again.' },
  /** O cliente descobriu que não há sessão antes mesmo de falar com o servidor. */
  'errors.noSession': { pt: 'Sessão não encontrada', en: 'Session not found' },
  'errors.googleLoad': {
    pt: 'Não foi possível carregar o Google',
    en: 'Could not load Google',
  },
} as const satisfies Catalog;
